import '../../../common/dashboard/filters/applied/applied_multiple_values_filter_view.js.coffee';# Added by Script 
import '../../../common/dashboard/filters/applied/applied_filter_view.js.coffee'
import '../../../common/dashboard/filters/subtype_filter_mixin.js.coffee'

Namespace 'CustomerVisualMode.Filters.Applied'

class CustomerVisualMode.Filters.Applied.AppliedSubTypeFilterView extends
Common.Dashboard.Filters.AppliedMultipleValuesFilterView
  initialize: ({filter, subtypes, isReadOnly}) ->
    super({filter, isReadOnly})
    _.extend(@, Common.Dashboard.Filters.SubtypeFilterMixin)
    @subtypes = subtypes

  _seeAll: ->
    @openSubtypeFilterModal()

  modalTitle: ->
    I18n.t 'common.session.filters.subtype.modal.applied_title'

  modalSubtitle: ->
    I18n.t 'common.session.filters.subtype.modal.applied_subtitle'
